import VersionMenu from "./nav-version.vue"
VersionMenu.install = (Vue) => Vue.component(VersionMenu.name, VersionMenu)
export default VersionMenu
